import { useState } from "react";
import "./App.css";

type TorrentResult = {
  movie: {
    title: string;
    year: number;
    rating: number;
    summary: string;
    image: string;
  };
  torrent?: {
    quality: string;
    size: string;
    url: string;
    magnet: string;
  };
};

function App() {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState<TorrentResult[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const search = async () => {
    if (!query) return;
    setLoading(true);
    setError("");
    setResults([]);
    try {
      const API_URL = "https://movie-worker.robertjan-vlak.workers.dev";
      const res = await fetch(
        `${API_URL}/api/search?query=${encodeURIComponent(query)}`,
      );
      const data = await res.json();
      console.log(data);
      if (data.error || !data.results.length)
        setError(data.message || "No results");
      else setResults(data.results);
    } catch (err) {
      setError("Failed to fetch: " + err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <header className="app-header">
        <div className="logo">
          <span className="logo-emoji">🎬</span>
          <h1>Movie Torrent Finder</h1>
        </div>
        <p className="subtitle">
          Quickly find torrents and magnet links for movies
        </p>
      </header>

      <div className="search-wrap">
        <div className="search-bar">
          <input
            className="search-input"
            placeholder="Search movie title..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && search()}
          />
          <div className="search-actions">
            <button className="btn primary" onClick={search} disabled={loading}>
              {loading ? "Searching..." : "Search"}
            </button>
            {query && (
              <button
                className="btn clear"
                onClick={() => {
                  setQuery("");
                  setResults([]);
                  setError("");
                }}
              >
                Clear
              </button>
            )}
          </div>
        </div>
        {error && <p className="error">{error}</p>}
      </div>

      {results.length > 0 && (
        <section className="results-section">
          <div className="grid">
            {results.map((result, i) => (
              <article key={i} className="card">
                <div className="card-left">
                  <img src={result.movie.image} alt={result.movie.title} />
                </div>
                <div className="card-right">
                  <div className="card-header">
                    <h2 className="title">
                      {result.movie.title}{" "}
                      <span className="year">({result.movie.year})</span>
                    </h2>
                    <div className="rating">⭐ {result.movie.rating}</div>
                  </div>
                  <p className="summary">{result.movie.summary}</p>

                  {result.torrent && (
                    <div className="torrent-actions">
                      <div className="torrent-meta">
                        <strong>{result.torrent.quality}</strong> •{" "}
                        {result.torrent.size}
                      </div>
                      <div className="links">
                        <a
                          className="btn link primary-outline"
                          href={result.torrent.url}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Download .torrent
                        </a>
                        <a
                          className="btn link"
                          href={result.torrent.magnet}
                          rel="noreferrer"
                        >
                          Magnet link
                        </a>
                      </div>
                    </div>
                  )}
                </div>
              </article>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}

export default App;
